import styled from 'styled-components';
import ResponsiveImage from '../image/responsive.js';
import { multiplyPx } from '../styled/utils';
import LinkHandler from '../link-handler';

const halfPx = multiplyPx(0.5);

export const LinkWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) =>
    `${theme.spacing.medium} ${theme.spacing.standard} ${theme.spacing.standard}`};
`;

export const Card = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;

  margin-bottom: ${({ theme }) => theme.spacing.standard};
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxshadow.small};

  &:hover {
    cursor: pointer;
    box-shadow: ${({ theme }) => theme.boxshadow.standard};
  }
`;

export const CardImage = styled(ResponsiveImage)`
  // aspect ratio placement to prevent reflow on image load
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.palette.lightBackground};
  // aspect ratio sizer to prevent reflow on image load
  padding-top: 58%;
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const CardTitle = styled.h3`
  position: absolute;
  bottom: -18px;
  max-width: 80%;
  margin-top: 0;
  margin-bottom: 0;
  padding: ${({ theme }) =>
    `${halfPx(theme.spacing.tiny)} ${theme.spacing.small}`};
  color: ${({ theme }) => theme.palette.white};
  font-size: ${({ theme }) => theme.fontsize.base};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  background: ${({ theme }) => theme.palette.darkBackground};
  color: ${({ theme }) => theme.palette.white};
`;

export const CardLink = styled(LinkHandler)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`;
